<div class="page">
  <ng-container *ngIf="isGettingOptions; else dynamicForm">
    <div class="my-4">
      <ng-container [ngTemplateOutlet]="skeleton"></ng-container>
    </div>
  </ng-container>
</div>
<ng-template #dynamicForm>
  <!-- Dynamic Form -->
  <form id="form" [formGroup]="form">
    <div class="row">
      <!-- Dynamic Controls Binding -->
      <ng-container *ngFor="let controlData of formFields">
        <section [ngSwitch]="controlData.type">
          <!-- text -->
          <ng-container
            *ngSwitchCase="'Text'"
            [ngTemplateOutlet]="Text"
            [ngTemplateOutletContext]="{
              data: controlData
            }"
          ></ng-container>

          <!-- number -->
          <ng-container
            *ngSwitchCase="'Number'"
            [ngTemplateOutlet]="Number"
            [ngTemplateOutletContext]="{
              data: controlData
            }"
          ></ng-container>

          <!-- textArea -->
          <ng-container
            *ngSwitchCase="'TextArea'"
            [ngTemplateOutlet]="TextArea"
            [ngTemplateOutletContext]="{
              data: controlData
            }"
          ></ng-container>

          <!-- RichText -->
          <ng-container
            *ngSwitchCase="'RichText'"
            [ngTemplateOutlet]="RichText"
            [ngTemplateOutletContext]="{
              data: controlData
            }"
          ></ng-container>

          <!-- RadioButtons -->
          <ng-container
            *ngSwitchCase="'RadioButton'"
            [ngTemplateOutlet]="RadioButton"
            [ngTemplateOutletContext]="{
              data: controlData
            }"
          ></ng-container>

          <!-- Date -->
          <ng-container
            *ngSwitchCase="'Date'"
            [ngTemplateOutlet]="Date"
            [ngTemplateOutletContext]="{
              data: controlData
            }"
          ></ng-container>
          <!-- Attachments -->
          <ng-container
            *ngSwitchCase="'Attachments'"
            [ngTemplateOutlet]="Attachments"
            [ngTemplateOutletContext]="{
              data: controlData
            }"
          ></ng-container>
          <!-- RatingSelector -->
          <ng-container
            *ngSwitchCase="'RatingSelector'"
            [ngTemplateOutlet]="RatingSelector"
            [ngTemplateOutletContext]="{
              data: controlData
            }"
          ></ng-container>
        </section>
      </ng-container>
    </div>

    <!-- RadioButton control -->
    <ng-template #RadioButton let-data="data" let-control="control">
      <div class="mt-1">
        <label class="form-label">
          {{ data.title[language] }}
          <span class="astrix-red" *ngIf="data.isRequired">*</span>
        </label>
        <!-- <app-radio-group
        class="d-block" -->
        <app-radio-group
          class="d-flex flex-wrap gap-4"
          bindValue="id"
          [formControlName]="data?.key"
          [control]="form | getControl : data?.key"
        >
          <app-radio-box
            *ngFor="let option of data?.options"
            class="mt-3 d-block"
            [disabled]="isDisabled"
            [value]="option.id"
          >
            {{ option.title[language] }}
          </app-radio-box>
        </app-radio-group>
      </div>
    </ng-template>

    <!-- text control -->
    <ng-template #Text let-data="data">
      <app-filed
        class="d-block mt-3"
        [formControlName]="data?.key"
        [control]="form | getControl : data?.key"
        [title]="data.title[language]"
        [placeholder]="data.title[language]"
      ></app-filed>
    </ng-template>

    <!-- number control -->
    <ng-template #Number let-data="data">
      <app-filed
        class="d-block mt-3"
        [formControlName]="data?.key"
        [control]="form | getControl : data?.key"
        [title]="data.title[language]"
        [placeholder]="data.title[language]"
      ></app-filed>
    </ng-template>

    <!--Attachment-->
    <ng-template #Attachments let-data="data">
      <app-attachments-files
        [title]="data.title[language]"
        [maxSize]="data?.size || 50"
        [accept]="'image/jpeg, image/png,image/jpg,application/pdf'"
        [formControlName]="data?.key"
        [control]="form | getControl : data?.key"
        (attachmentUploadEvent)="getAttachments($event)"
      ></app-attachments-files>
    </ng-template>
    <!-- Text Area control -->
    <ng-template #TextArea let-data="data">
      <app-textarea-filed
        class="d-block mt-3"
        [formControlName]="data?.key"
        [control]="form | getControl : data?.key"
        [title]="data.title[language]"
        [placeholder]="data.title[language]"
      ></app-textarea-filed>
    </ng-template>

    <!-- RichText control -->
    <ng-template #RichText let-data="data">
      <div class="mt-1">
        <label class="mt-1 me-1 form-label">
          {{ data.title[language] }}
        </label>
        <span *ngIf="data.isRequired" style="color: red">*</span>
        <angular-editor
          [formControlName]="data?.key"
          [control]="form | getControl : data?.key"
          [config]="editorConfig"
        ></angular-editor>
      </div>
    </ng-template>

    <!-- Date control -->
    <ng-template #Date let-data="data">
      <app-nz-date-picker
        class="d-block mt-3"
        [placeholder]="data.title[language]"
        [title]="data.title[language]"
        [formControlName]="data?.key"
        [control]="form | getControl : data?.key"
      ></app-nz-date-picker>
      <!-- [minDate]="'today'" -->
    </ng-template>

    <!-- RatingSelector control -->
    <ng-template #RatingSelector let-data="data">
      <label class="form-label mt-4">
        {{ data.title[language] }}
        <span class="astrix-red" *ngIf="data.isRequired">*</span>
      </label>
      <div class="row">
        <div class="col-6">
          <app-select
            class="d-block"
            [formControlName]="data?.key"
            [control]="form | getControl : data?.key"
            [placeholder]="data.title[language]"
            [items]="data?.options"
            [clearable]="true"
            [bindVlaue]="'id'"
            [search]="false"
            [bindLabel]="language == 'en' ? 'title.en' : 'title.ar'"
            (change)="rangeSelected($event, data?.key)"
          ></app-select>
        </div>
        <div class="col-6">
          <app-filed
            class="d-block"
            [formControlName]="data?.key + 'Value'"
            [control]="form | getControl : data?.key + 'Value'"
            [placeholder]="'shared.selectRate' | translate"
          ></app-filed>
        </div>
      </div>
    </ng-template>
  </form>
</ng-template>
<!-- loader skeleton for the form -->
<ng-template #skeleton>
  <app-skeleton-loader mode="table"></app-skeleton-loader>
  <app-skeleton-loader mode="table"></app-skeleton-loader>
  <app-skeleton-loader mode="table"></app-skeleton-loader>
</ng-template>
